import { Component, OnInit, ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { IDropdownHieararchy } from "../../../interfaces/idropdownconfig";
import { IDropDownView } from "../../../interfaces/idropdowns";
import { DropdownHierarchyService } from "../../../services/dropdownhierarchy.service";
import { ToastrService } from "ngx-toastr";
import { ConfirmationModalComponent } from "../../confirmationmodal/confirmationmodal.component";
import { DropdownHierarchyItemComponent } from "../dropdownhierarchyitem/dropdownhierarchyitem.component";

@Component({
    selector: "dropdownhierarchy",
    templateUrl: "./dropdownhierarchy.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ConfirmationModalComponent, DropdownHierarchyItemComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})

export class DropdownHierarchyComponent implements OnInit {
    dropdownHieararchy: IDropdownHieararchy;
    availableDropDowns: IDropDownView[];
    @ViewChild("confirmModal") public confirmModal;

    constructor(private activatedRoute: ActivatedRoute, private dropdownHieararchyService: DropdownHierarchyService, private toastsMgr: ToastrService) {
    }

    ngOnInit(): void {
        let dropdownHieararchy: IDropdownHieararchy = this.activatedRoute.snapshot.data["dropdownhierarchy"] as IDropdownHieararchy;
        this.setDropDownHieararchy(dropdownHieararchy);
        this.availableDropDowns = this.activatedRoute.snapshot.data["availabledropdowns"] as IDropDownView[];
    }

    setDropDownHieararchy(dropdownHiearchy: IDropdownHieararchy): void {
        this.dropdownHieararchy = dropdownHiearchy;
        if (!this.dropdownHieararchy) {
            this.dropdownHieararchy = <IDropdownHieararchy>{ id: null,dropDownId:null, items: [] };
        }
    }

    onAccept(): void {
         this.dropdownHieararchyService.save(this.dropdownHieararchy).subscribe((i: IDropdownHieararchy) => {
            this.setDropDownHieararchy(i);
            this.toastsMgr.success("Dropdown hierarchy saved successfully.");
        });
    }

    onSave(): void {
        this.confirmModal.openModal();
    }
}



